
import React from "react";
import { Shield } from "lucide-react";
import { Table, TableBody } from "@/components/ui/table";
import PermissionTableHeader from "./PermissionTableHeader";
import PermissionRow from "./PermissionRow";
import RoleBadge from "./RoleBadge";
import { Permission, Role, Resource, PermissionType } from "@/hooks/rollenbeheer/types";

interface RoleSectionProps {
  role: Role;
  permissions: Permission[];
  onUpdatePermission: (role: Role, resource: Resource, permissionType: PermissionType, value: boolean) => void;
}

const RoleSection: React.FC<RoleSectionProps> = ({ role, permissions, onUpdatePermission }) => {
  // Sort permissions by resource label
  const sortedPermissions = [...permissions].sort((a, b) => {
    const labelA = a.resource;
    const labelB = b.resource;
    return labelA.localeCompare(labelB);
  });

  return (
    <div>
      <div className="flex items-center mb-4">
        <Shield className="mr-2 h-5 w-5" />
        <h3 className="text-lg font-semibold">
          <RoleBadge role={role} />
        </h3>
      </div>
      
      <Table>
        <PermissionTableHeader />
        <TableBody>
          {sortedPermissions.map((permission) => (
            <PermissionRow
              key={permission.id}
              permission={permission}
              role={role}
              onUpdatePermission={onUpdatePermission}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default RoleSection;
